import { useRef } from 'react'

// Referencia que siempre apunta al valor del último render. Se usa en callbacks asíncronos
// (subidas de imágenes, carga del CSV) para no trabajar con valores de cuando empezaron.
export const useLatestRef = value => {
  const ref = useRef(value)
  ref.current = value
  return ref
}

export default useLatestRef
